import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeElapsed',
  pure: true,
  standalone: true
})

export class TimeElapsedPipe implements PipeTransform {

  transform(value: string): string {
    const currentDateTime = new Date();
    const currentUtcDateTime = new Date(Date.UTC(
      currentDateTime.getUTCFullYear(),
      currentDateTime.getUTCMonth(),
      currentDateTime.getUTCDate(),
      currentDateTime.getUTCHours(),
      currentDateTime.getUTCMinutes(),
      currentDateTime.getUTCSeconds()
    ));
    const timeDifference = currentUtcDateTime.getTime() - new Date(value).getTime();

    const minutesDifference = Math.floor(timeDifference / (1000 * 60));
    if (minutesDifference < 1) {
      return 'Just now';
    }
    else if (minutesDifference < 60) {
      return `${minutesDifference} min${minutesDifference !== 1 ? 's' : ''} ago`;
    }
    else {
      const hoursDifference = Math.floor(minutesDifference / 60);
      const daysDifference = Math.floor(hoursDifference / 24);

      if (daysDifference > 0) {
        return `${daysDifference} day${daysDifference > 1 ? 's' : ''} ago`;
      } else {
        return `${hoursDifference} hour${hoursDifference > 1 ? 's' : ''} ago`;
      }
    }
  }
}